import React from 'react'
import { Provider } from 'react-redux'
import GlobalStyles from 'src/assets/styles/globalStyle'
import { store, persistor } from './redux/store'
import Boot from './redux/boot'
import Routes from './router'
import AppProvider from './AppProvider'
import { PersistGate } from 'redux-persist/integration/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from 'src/config/authConfig';
import { ThemeProvider } from './theme/ThemeContext'

// const msalInstance = new PublicClientApplication(msalConfig);

const App = () => (

  <ThemeProvider>
    {/* <MsalProvider instance={msalInstance}> */}
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppProvider>
              <>
                <Routes />
              </>
            </AppProvider>
          </PersistGate>
        </Provider>
      </GoogleOAuthProvider>
    {/* </MsalProvider> */}
  </ThemeProvider>
)

Boot()
  .then(() => App())
  .catch(error => console.error(error))

export default App
